import {Utils} from './Utils';

export interface ModalConfig {
    dropdown: HTMLElement;
    trigger: HTMLElement;
    container?: HTMLElement;
}

export class Dropdown {
    protected isActive: boolean;
    private readonly elements: {
        dropdown: HTMLElement,
        trigger: HTMLElement,
        container?: HTMLElement
    };

    constructor({dropdown, trigger, container}: ModalConfig) {
        this.isActive = false;
        this.elements = {dropdown, trigger, container};
        this.init();
    }

    protected onContainerClick(evt: Event): void {
        if (!this.isActive) return;
        const
            target = evt.target as HTMLElement,
            {dropdown, trigger} = this.elements,
            notDropdown = target.closest(`.${dropdown.className.split(" ")[0]}`) === null,
            notTrigger = target.closest(`.${trigger.className.split(" ")[0]}`) === null;

        if (notDropdown && notTrigger) this.close();
    }

    protected onTriggerClick(evt: Event): void {
        evt.preventDefault();
        this.toggle(evt.currentTarget as HTMLElement);
    }

    public toggle(trigger: HTMLElement): void {
        const {dropdown} = this.elements;
        this.isActive = !this.isActive;
        Utils.toggleClass(dropdown, `is-active`);

        if (this.isActive) {
            Utils.toggleClass(trigger, `is-triggered`);
        } else {
            Utils.removeClass(trigger, `is-triggered`);
        }
    }

    public close(): void {
        const {dropdown, trigger} = this.elements;
        this.isActive = false;
        Utils.removeClass(dropdown, `is-active`);
        Utils.removeClass(trigger, `is-triggered`);
    }

    protected init(): void {
        const {trigger, container} = this.elements;
        if (trigger && container) {
            container.addEventListener(`click`, (evt) => this.onContainerClick(evt), false);
            trigger.addEventListener(`click`, (evt) => this.onTriggerClick(evt), false);
        }
    }

    get state(): string {
        return this.isActive ? `opened` : `closed`;
    }
}